import { Component, EventEmitter, OnDestroy, OnInit, Output } from "@angular/core";
import { HomeService } from "@gtmhub/home/services/home";
import { InsightboardService } from "@gtmhub/insightboards";
import { IReport } from "@gtmhub/reporting/models";
import { SubNavOption } from "@webapp/navigation/models/sub-nav-options.models";
import { FeatureToggleV2Service } from "@gtmhub/featureToggle";
import { BaseRecentSubNav } from "../services/base-recent-sub-nav";
import { NavigationItemsFacade } from "@gtmhub/uxcustomization/navigation-items-facade";

@Component({
  selector: "gh-reports-sub-navigation",
  templateUrl: "./reports-sub-navigation.component.html",
})
export class ReportsSubNavigationComponent extends BaseRecentSubNav implements OnInit, OnDestroy {
  @Output() titleChange = new EventEmitter<string>();
  public options: SubNavOption[] = [
    // { label: "My Reports", state: "gtmhub.lists" },
    { label: "All Reports", state: "gtmhub.lists" },
  ];
  public customReportOptions: SubNavOption[] = [];
  public hideListsFeatureFlag: boolean;

  private sectionTitle = "Reports";

  constructor(
    private homeService: HomeService,
    private insightboardService: InsightboardService,
    private featureToggleV2Service: FeatureToggleV2Service,
    protected navigationItemsFacade: NavigationItemsFacade
  ) {
    super();
    const performanceReportId = this.getPerformanceReportId();
    const processReportId = this.getProcessReportId();
    if (performanceReportId && processReportId) {
      this.customReportOptions.push(this.buildPerformanceReportOption(performanceReportId));
      this.customReportOptions.push(this.buildProcessReportOption(processReportId));
    } else {
      this.insightboardService.getReports().then((reports: IReport[]) => {
        this.homeService.cachedReports = reports;
        const performanceReport = this.homeService.cachedReports.find((report) => report.name.toLowerCase() === "performance report");
        const processReport = this.homeService.cachedReports.find((report) => report.name.toLowerCase() === "process report");
        this.customReportOptions.push(this.buildPerformanceReportOption(performanceReport.id));
        this.customReportOptions.push(this.buildProcessReportOption(processReport.id));
      });
    }
    this.setupEntityTypes(["list"], "lists");
  }

  ngOnInit(): void {
    this.featureToggleV2Service.isFeatureAvailable("hide-lists").then((enabled) => {
      this.hideListsFeatureFlag = enabled;
      if (!enabled) {
        super.ngOnInit();
      }
    });
    this.titleChange.emit(this.sectionTitle);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  private getReportId = (reportName: string) => {
    if (!this.homeService.cachedReports) return null;
    const performanceReport = this.homeService.cachedReports.find((report) => report.name.toLowerCase() === reportName);
    if (!performanceReport) return null;
    return performanceReport.id || null;
  };

  private getPerformanceReportId = () => this.getReportId("performance report");

  private getProcessReportId = () => this.getReportId("process report");

  private buildPerformanceReportOption = (reportId: string) => {
    return { label: "Performance", state: "gtmhub.insightboard", icon: "performance", stateOptions: { dashboardId: reportId } };
  };

  private buildProcessReportOption = (reportId: string) => {
    return { label: "Process", state: "gtmhub.insightboard", icon: "process", stateOptions: { dashboardId: reportId } };
  };
}
